var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',[(_vm.iconfont)?_c('i',{staticClass:"gj-icon"},[_c('svg',{attrs:{"aria-hidden":"true","width":"1em","height":"1em","fill":"currentColor"}},[_c('use',{attrs:{"xlink:href":'#' + _vm.iconfont}})])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }